import { FC, useCallback } from 'react';
import {
  addUserRolesAction,
  deleteUserRolesAction,
} from '../actions/update-user-roles-actions';
import { Role, UserRolesInput } from '../types/members-types';
import UpdateRolesModal from '../components/UpdateRolesModal';
import UpdateUserRolesStore from '../stores/update-user-roles-store';
import { useSnapshot } from 'valtio';
import { closeUpdateUserRolesModal } from '../store-actions/update-user-roles-store-actions';

const UpdateUserRolesContainer: FC<
  React.PropsWithChildren<UpdateUserRolesContainerProps>
> = ({ availableRoles }) => {
  const { isModalVisible, selectedMember } = useSnapshot(UpdateUserRolesStore);

  const onAddRole = useCallback(async (userRolesInput: UserRolesInput) => {
    await addUserRolesAction(userRolesInput);
  }, []);

  const onRemoveRole = useCallback(async (userRolesInput: UserRolesInput) => {
    await deleteUserRolesAction(userRolesInput);
  }, []);

  if (!isModalVisible) {
    return null;
  }

  return (
    <UpdateRolesModal
      member={selectedMember}
      open={isModalVisible}
      onClose={closeUpdateUserRolesModal}
      onAddRole={onAddRole}
      onRemoveRole={onRemoveRole}
      availableRoles={availableRoles}
    />
  );
};

export interface UpdateUserRolesContainerProps {
  availableRoles: Role[];
}

export default UpdateUserRolesContainer;
